import React, { useEffect, useState } from 'react'
// import Stepper from './Stepper'
import { connect } from 'react-redux'
import { contracterActions } from '../../../store/actions'
import moment from 'moment'

import Input from '../../../module/input'
import Calendar from '../../../module/calendar'
import { regConstants } from '../../../store/constants'
import history from '../../../route/history'
import Contracter from '../index'
import { valid } from '../../../hook/valid'
import { commons } from '../../../hook/common'

/**
 * 구매확인서 1단계 / 일반정보 입력
 * @desc  !! 공급물품 용도명세라는 항목은 4월에 추가하는 것으로 협의(AB)
 */
const CertificateStep01 = (props) => {
  const nodeBaseInfo = {
    docid: {
      title: '전자문서번호',
      type: 'text',
      length: 40,
      readOnly: true,
      required: true,
      rowClassName: 'flex-l m-b-10',
    },
    issueNm: {
      title: '수신처(발급기관)',
      type: 'text',
      length: 100,
      required: true,
      message: '수신처를 입력해주세요.',
      rowClassName: 'flex-l m-b-10',
    },
    bfmdfcnfrmprch: {
      title: '변경전 구매확인서번호',
      type: 'text',
      length: 40,
      rowClassName: 'flex-l m-b-10',
    },
    /********* 신청인 **********/
    lctorgnm: {
      title: '상호',
      type: 'text',
      length: 100,
      required: true,
      readOnly: true,
      rowClassName: 'flex-l m-b-10',
    },
    lctceonm: {
      title: '성명',
      type: 'text',
      length: 40,
      required: true,
      message: '신청인 성명을 입력해주세요.',
      rowClassName: 'flex-l m-b-10',
    },
    lctprtid: {
      title: '사업자등록번호',
      type: 'text',
      length: 10,
      required: true,
      readOnly: true,
      rowClassName: 'flex-l m-b-10',
    },
    lctaddr1: {
      title: '주소',
      inputTitle: '우편번호',
      type: 'text',
      placeholder: '우편번호',
      required: true,
      message: '우편번호를 입력해주세요.',
      rowClassName: 'flex-l m-b-5',
    },
    lctaddr2: {
      type: 'text',
      inputTitle: '주소',
      required: true,
      placeholder: '주소',
      message: '주소를 입력해주세요.',
      rowClassName: 'flex-l m-b-5',
    },
    lctaddr3: {
      type: 'text',
      inputTitle: '상세주소',
      placeholder: '상세주소',
      length: 100,
      rowClassName: 'flex-l m-b-15',
    },
    /********* 공급자 **********/
    splyCmpyNm: {
      title: '상호',
      type: 'text',
      length: 100,
      required: true,
      message: '공급자 상호를 입력해주세요.',
      rowClassName: 'flex-l m-b-10',
    },
    splynm: {
      title: '성명',
      type: 'text',
      length: 40,
      required: true,
      message: '공급자 성명을 입력해주세요.',
      rowClassName: 'flex-l m-b-10',
    },
    splyprtnum: {
      title: '사업자등록번호',
      type: 'text',
      length: 10,
      required: true,
      placeholder: "('-')없이 숫자만 입력",
      message: '공급자 사업자등록번호를 입력해주세요.',
      rowClassName: 'flex-l m-b-10',
    },
    splyaddr1: {
      title: '주소',
      type: 'text',
      inputTitle: '우편번호',
      required: true,
      placeholder: '우편번호',
      message: '우편번호를 입력해주세요.',
      rowClassName: 'flex-l m-b-5',
    },
    splyaddr2: {
      type: 'text',
      required: true,
      inputTitle: '주소',
      placeholder: '주소',
      message: '주소를 입력해주세요.',
      rowClassName: 'flex-l m-b-5',
    },
    splyaddr3: {
      type: 'text',
      inputTitle: '상세주소',
      placeholder: '상세주소',
      length: 100,
      rowClassName: 'flex-l m-b-15',
    },
    /********* 공급자에게 전자문서를 전달하는경우 **********/
    splycd: {
      title: '수발신인식별자',
      type: 'text',
      length: 60,
      rowClassName: 'flex-l m-b-10',
    },
    splyid: {
      title: '상세수발신인식별자',
      type: 'text',
      length: 60,
      rowClassName: 'flex-l m-b-10',
    },
    /********* 공급자에게 발급사실을 통지하는 경우 **********/
    emlAddr: {
      title: '이메일주소',
      type: 'text',
      length: 320,
      regex: regConstants.email,
      regErrMsg: '이메일 주소 형식이 아닙니다.',
      rowClassName: 'flex-l m-b-10',
    },
  }

  const [state, setState] = useState({})
  const [showContracter, setShowContracter] = useState(false)
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))

  /**
   * 화면 진입시 초기값 설정
   */
  useEffect(() => {
    const value = props.search?.split('=')[1]
    let key = props.search?.split('=')[0]

    if (!value && !key) {
      //신규작성
      setShowContracter(true)
    } else if (key === '?id' && value) {
      //문서번호 발급이후
      setShowContracter(false)
      let docInfo = JSON.parse(sessionStorage.getItem(value))?.step1

      if (!docInfo) {
        window.location.replace('/service/apply/1')
      } else {
        docInfo.issueNm = 'EKTNET'
        setState(docInfo)
      }
    }
    commons.preventKeyDown()
  }, [])

  /**
   * 임시저장 호출 후 콜백
   */
  useEffect(() => {
    if (props.isCalled === true) {
      let docInfo = JSON.parse(sessionStorage.getItem(props.totalData?.step1?.docid))

      if (props.totalData?.step1?.docid) {
        docInfo.step1 = props.stepData
        sessionStorage.setItem(props.totalData?.step1?.docid, JSON.stringify(docInfo))
        history.push('/service/apply/2?id=' + props.totalData?.step1?.docid)
      }
    }

    props.setCalled(false)
  }, [props.isCalled])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  /**
   * 다음화면 진입을 위한 유효성 체크
   */
  const goStepNext = () => {
    setState({ ...state, submitted: !state.submitted })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (!state?.[key] || state?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      //유효성 체크
      if (message === null && state?.[key]?.length > 0 && !!node[key].regex) {
        let regex = node[key].regex
        let value = state?.[key]
        let regResult = regex.test(value)

        if (!regResult) {
          message = node[key]?.regErrMsg
          errCnt++
        } else {
          message = null
        }
      }

      //사업자번호
      if (key === 'splyprtnum') {
        if (!valid.checkbizNo(state.splyprtnum)) {
          message = '유효한 사업자번호가 아닙니다.'
          errCnt++
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        inputRef.current[index].focus()
      }
    })

    if (errCnt > 0) return

    setState({ ...state, isCall: true })
    props.saveStep1(state)
  }

  const generateRow = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let withBtn = node?.withBtnName && <button className="btn btn-white">{node?.withBtnName}</button>
    let className = 'form-control input-text '
    let wrapperClassName = node?.wrapperClassName
    let rowClassName = node?.rowClassName ? node?.rowClassName : 'flex-sb-m m-b-15'
    let star = node?.title && node?.required === true ? <span className="required">*</span> : ''
    node?.readOnly === true && (className += 'disabled ')

    return (
      <div className={rowClassName}>
        <h4 className="title">
          {node?.title}
          {star}
        </h4>
        <Input
          id={key}
          name={key}
          type={node.type}
          value={state?.[key] || ''}
          inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
          ref={(ref) => (inputRef.current[idx] = ref)}
          wrapperClassName={wrapperClassName}
          className={className + node?.className}
          placeholder={node?.placeholder}
          message={node?.message}
          onChange={handleChange}
          readOnly={node.readOnly}
          required={node.required}
          flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
          length={node.length}
          errMessage={node.errMessage}
        />
        {withBtn}
      </div>
    )
  }

  return (
    <React.Fragment>
      {showContracter && <Contracter />}

      <div className="lineBox cardBox m-t-20">
        <ul className="step-detail">
          <li>
            {generateRow('docid')} {/* 전자문서번호 */}
          </li>
          <li>
            {generateRow('issueNm')} {/* 수신처 */}
          </li>
        </ul>
      </div>

      <div className="m-t-20 cardBox">
        <div className="detail-title">
          신청인 정보<span className="required">*</span>
          <span className="des">(상호, 성명, 사업자등록번호, 주소)</span>
        </div>
        <div className="lineBox">
          <ul className="step-detail">
            <li>
              {generateRow('lctorgnm')} {/* 상호 */}
            </li>
            <li>
              {generateRow('lctceonm')} {/* 성명 */}
            </li>
            <li>
              {generateRow('lctprtid')} {/* 사업자등록번호 */}
            </li>
            <li className="type-addr">
              {generateRow('lctaddr1')} {/* 주소1 */}
              {generateRow('lctaddr2')} {/* 주소2 */}
              {generateRow('lctaddr3')} {/* 주소3 */}
            </li>
          </ul>
        </div>
      </div>

      <div className="m-t-20 cardBox">
        <div className="detail-title">
          공급자 정보<span className="required">*</span>
          <span className="des">(상호, 성명, 사업자등록번호, 주소)</span>
        </div>
        <div className="lineBox">
          <ul className="step-detail">
            <li>
              {generateRow('splyCmpyNm')} {/* 상호 */}
            </li>
            <li>
              {generateRow('splynm')} {/* 성명 */}
            </li>
            <li>
              {generateRow('splyprtnum')} {/* 사업자등록번호 */}
            </li>
            <li className="type-addr">
              {generateRow('splyaddr1')} {/* 주소1 */}
              {generateRow('splyaddr2')} {/* 주소2 */}
              {generateRow('splyaddr3')} {/* 주소3 */}
            </li>
          </ul>

          <div className="step-Item2">공급자에게 전자문서로 전달하는 경우 입력(선택사항)</div>
          <ul className="step-detail">
            <li>
              {generateRow('splycd')} {/* 수발신인식별자 */}
            </li>
            <li>
              {generateRow('splyid')} {/* 상세수발신인식별자 */}
            </li>
          </ul>

          <div className="step-Item2">공급자에게 발급사실을 통지하는 경우 입력(선택사항)</div>
          <ul className="step-detail">
            <li>
              {generateRow('emlAddr')} {/* 이메일주소 */}
            </li>
          </ul>

          <div className="step1-guide">
            <p>
              구매확인서 발급사실을 공급자에게 신속히 메일로 알려드리기 위해 기재하는 사항이며, 구매확인서 서류가 전달되진
              않습니다.
            </p>
            <p>수발신인식별자 기재시는 본 항목을 기재하실 필요는 없습니다.</p>
            <p>
              <span className="caution">
                이메일주소를 잘못 기재하여 제3자에게 메일 전송 시, 그 책임은 구매확인 신청인에게 있습니다.
              </span>
              <br />
              <span>(문서복사시 이메일정보를 다시 확인하시기 바랍니다.)</span>
            </p>
          </div>
        </div>
      </div>

      <div className="detail-btn">
        <button className="btn btn-white float-l" onClick={props.doDelete}>
          삭제
        </button>
        <button className="btn btn-blue" onClick={goStepNext}>
          다 음
        </button>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.contracter?.data?.step1,
    totalData: state.contracter.data,
    isCalled: state.contracter?.isCalled,
  }
}

const actionCreators = {
  saveStep1: contracterActions.saveStep1,
  alert: contracterActions.alert,
  setCalled: contracterActions.setCalled,
}

export default connect(mapStateToProps, actionCreators)(CertificateStep01)
